import { createIcon } from '@chakra-ui/react';
import { jsx as _jsx } from "react/jsx-runtime";
export var CheckIcon = createIcon({
  displayName: 'Warning',
  viewBox: '0 0 17 13',
  path: /*#__PURE__*/_jsx("path", {
    d: "M5.33858 10.0473L1.59763 6.22994L0.32373 7.5207L5.33858 12.638L16.1039 1.65278L14.839 0.362022L5.33858 10.0473Z",
    fill: "#1476AD"
  })
});
//# sourceMappingURL=CheckIcon.js.map